<template>
  <v-container fluid class="shift-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Shift</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Shift</p>
                        <v-text-field
                          class="mb-4"
                          v-model="shift.shiftcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Shift Code"
                          persistent-hint
                          single-line hint="Enter the shift code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="shift.shiftname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Shift Name"
                          persistent-hint
                          single-line hint="Enter the shift name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="shift.shifttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the shift type">
                        </v-select>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/shift/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertShift()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      shift: {},
      items: ['Shift', 'Special Shift'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Shift', ['isReceiving'])
  },
  methods: {
    ...mapActions('Shift', ['insertShiftRequest', 'getShiftsRequest']),
    checkError(){
      if(!this.shift.shiftcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.shift.shiftname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.shift.shifttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertShift() {
      if(!this.checkError()) return;
      await this.insertShiftRequest(this.shift);
      this.getShiftsRequest();
      router.push('/shift/list');
    },
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
